/**
 * Demo pública (business id reservado). Las rutas siguen el mismo menú multi-tenant.
 *
 * Configurá el número de WhatsApp comercial en build:
 *   REACT_APP_WHATSAPP_LANDING=56912345678  (solo dígitos, sin +)
 */
export const DEMO_BUSINESS_ID = 'demo';

export const DEMO_MENU_URL = '/menu/demo';

/** Catálogo demo (ruta App: /menu/:businessId/catalog) */
export const DEMO_CATALOG_URL = '/menu/demo/catalog';

const WHATSAPP_PREFILL = 'Hola quiero probar SoluQR';

function whatsappDigits() {
  const raw = process.env.REACT_APP_WHATSAPP_LANDING || '';
  const digits = String(raw).replace(/\D/g, '');
  return digits || '56900000000';
}

/** wa.me con texto prellenado (comercial landing). */
export const WHATSAPP_LANDING_URL = `https://wa.me/${whatsappDigits()}?text=${encodeURIComponent(
  WHATSAPP_PREFILL
)}`;
